import type { TranslatedString } from '@interfaces/shared';
import { formatMoneyValue } from '@utils/moneyFormatting';
import { Box, Typography } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';
import { useLocalization } from '../../../../../hooks/useLocalization';

export type WithdrawalNetSummaryProp = {
  netAmountLabel: TranslatedString | undefined;
  amountCents: number | undefined;
  netAmountCents: number | undefined;
};

export const WithdrawalNetSummary = ({
  netAmountLabel,
  amountCents,
  netAmountCents,
}: WithdrawalNetSummaryProp) => {
  const { translateBackendString } = useLocalization();
  const { t } = useTranslation(['components', 'transfer']);

  return (
    <>
      <Box>
        <Typography variant='labelLarge' color='textSecondary'>
          {t('components:transferModal.withdrawalMode')}
        </Typography>
        <Typography variant='bodyLarge' sx={{ fontWeight: 600 }}>
          {t('components:transferModal.net')}
        </Typography>
      </Box>
      <Box>
        <Typography variant='labelLarge' color='textSecondary'>
          {translateBackendString(netAmountLabel) ||
            t('components:transferModal.netAmount')}
        </Typography>
        <Typography variant='bodyLarge' sx={{ fontWeight: 600 }}>
          {formatMoneyValue(netAmountCents)}
        </Typography>
      </Box>
      <Box>
        <Typography variant='labelLarge' color='textSecondary'>
          {t(
            'transfer:withdrawal.withdrawalBreakDown.feesAndTaxTypes.WITHHOLDING_TAX',
          )}
        </Typography>
        <Typography variant='bodyLarge' sx={{ fontWeight: 600 }}>
          {formatMoneyValue((amountCents ?? 0) - (netAmountCents ?? 0))}
        </Typography>
      </Box>
    </>
  );
};
